import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';
import { Redirect } from 'react-router';

import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Placeholder } from 'modules/common/components/Placeholder';
import { ProjectsAccessGuard } from 'modules/projects/components/ProjectsAccessGuard';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { projectsRoutesConfig } from 'domains/projects/routes';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useJWTManagerPermissions } from 'domains/jwtToken/hooks/useJWTManagerPermissions';

const ProjectPage = loadable(
  async () => {
    const module = await import('./ProjectPage');

    return module.ProjectPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsPath = chainsRoutesConfig.chains.generatePath({ isLoggedIn: true });
const projectsPath = projectsRoutesConfig.projects.generatePath();

// todo: refactor to remove unnecessary guards
export const ProjectPageContainer = () => {
  const { authToken, isLoggedIn, isLoggingIn } = useAuth();
  const { isAccountInitializing } = useAccount();

  const { allowedJWTsCountLoading, hasReadAccess: hasProjectsAccess } =
    useJWTManagerPermissions();
  const { initalLoading: accountStatusLoading, isFreemium } =
    useAccountStatus();

  const hasAuthToken = Boolean(authToken);
  const shouldLogIn = hasAuthToken && !isLoggedIn;

  const loading =
    isLoggingIn ||
    shouldLogIn ||
    isAccountInitializing ||
    accountStatusLoading ||
    allowedJWTsCountLoading;

  const shouldForceRedirect = isLoggedIn && !isFreemium && !hasProjectsAccess;

  return (
    <NoSSRGuard>
      <Placeholder hasPlaceholder={loading} placeholder={<OverlaySpinner />}>
        <Placeholder
          hasPlaceholder={!isLoggedIn}
          placeholder={<Redirect to={projectsPath} />}
        >
          <GuardAccountPermission
            permission={AccountPermission.UsageData}
            shouldForceRedirect={shouldForceRedirect}
            shouldHideAlert
            shouldRedirect
          >
            <ProjectsAccessGuard fallback={chainsPath}>
              <ProjectPage />
            </ProjectsAccessGuard>
          </GuardAccountPermission>
        </Placeholder>
      </Placeholder>
    </NoSSRGuard>
  );
};
